/*
IMPORTANT - This enum translates to the SalesSqftDisplayType in the core library for the back-end's use!
 */
export enum SalesSqftDisplayType {
  SALES_AREA = 'SALES_AREA',
  TOTAL_AREA = 'TOTAL_AREA'
}
